import React, { useState, useEffect } from 'react';
import { triggerLogOut } from '../../Utils/utils';

const Timer = () => {
  const [timer, setTimer] = useState(0);

  // Function to get the timer state from Cache Storage
  const getStoredTimer = async () => {
    try {
      const cache = await caches.open('timer-cache');
      const response = await cache.match('timerState'); 
      if (response) {
        const timerData = await response.json(); 
        
        return timerData.timer || 0;  // Return timer state if available
      }
    } catch (error) {
      console.error('Error accessing cache:', error);
    }
    return 0; // Default to 0 if no timer state found
  };

  useEffect(() => {
    // Initialize timer from Cache Storage
    const loadTimer = async () => {
      const initialTimer = await getStoredTimer();
      setTimer(initialTimer);
    };

    loadTimer();
  }, []);

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => {
          if (prevTimer <= 1) {
            clearInterval(interval);
            caches.open('timer-cache').then((cache) => {
              cache.delete('timerState');
            }); 
            triggerLogOut(true);
            window.location.reload();
            return 0; // Set timer to zero
          }
          const timerData = JSON.stringify({ timer :  prevTimer - 1 });
            // Use Cache API to store the timer data
            caches.open('timer-cache').then((cache) => {
              const response = new Response(timerData, { status: 200, statusText: 'OK' });
              cache.put('timerState', response);                       
            });

          return prevTimer - 1;
        });
      }, 1000); // Update every second

      // Cleanup interval on component unmount
      return () => clearInterval(interval);
    } 
  }, [timer]);

  return (
    timer > 0 && ( <div className="timer-container">
      <h1>This session will expire in <span className="timer">{timer} seconds</span></h1>
    </div> )
  );
};

export default Timer;
